import { connect } from 'react-redux';
import { isAuthenticated } from '../../../modules/user/selectors';
import { getEverythingElseIds, getMoreChunks, hasEverythingElseBets } from '../selectors';
import EverythingElse from './EverythingElse';

const mapStateToProps = state => ({
  bets: getEverythingElseIds(state),
  hasBets: hasEverythingElseBets(state),
  moreBets: getMoreChunks(state),
  showLoadPreviousWeek: isAuthenticated(state)
});

export default connect(mapStateToProps)(EverythingElse);
